<div class="page">
    <app-header title="{{ 'documentsGrid.pageTitle' | translate }}"> </app-header>
    <ngx-loading [show]="showSpinner"></ngx-loading>
     <div class="page-content" >
        <div *ngIf="currentUser?.organization.isParentOrganization" class="table-top">
            <div class="section-header">{{ "documentsGrid.pageTitle" | translate }}</div>
            <app-button [title]="'documentsGrid.addDocument' | translate" (buttonClick)="addNewDocument()"
                icon="fa-plus">
            </app-button>
        </div>
        <form [formGroup]="form">
            <div class="row g-3">
            <div class="col-sm-2">
                <label>
                    {{ "form.dateFrom" | translate }}
                </label>
                <input type="date"
                class="form-control form-control" placeholder="Fecha desde" name="startDate"
                formControlName="startDate" [(ngModel)]="model.startDate"
                >
            </div>
            <div class="col-sm-2">
                <label>
                    {{ "form.dateUntil" | translate }}
                </label>
                <input type="date"
                class="form-control form-control" placeholder="Fecha hasta" name="endDate"
                formControlName="endDate" [(ngModel)]="model.endDate"
                >
            </div>
            <div class="col-sm-2">
                <label>
                    {{ "form.organization" | translate }}
                </label>
                <input type="text"
                class="form-control form-control" placeholder="" name="organization"
                formControlName="organization" [(ngModel)]="model.organization"
                >
            </div>
        </div>
        <div class="row g-3">
            <div class="col-sm-2">
                <label>
                    {{ "form.sintraId" | translate }}
                </label>
                <input type="text"
                class="form-control form-control" placeholder="" name="sintraId"
                formControlName="sintraId" [(ngModel)]="model.sintraId"
                >
            </div>
            <div class="col-sm-2">
                <label>
                    {{ "form.certificateType" | translate }}
                </label>
            <select class="form-control"  name="constancyType" formControlName="constancyType" [(ngModel)]="model.constancyType">
                <option value="default">--{{ "form.certificateType" | translate }}--</option>
                <option *ngFor="let item of constancyTypeEnum" [ngValue]="item.value">{{item.text}}</option>
            </select>
            </div>
            <div class="col-sm-2">
                <label>
                    {{ "form.status" | translate }}
                </label>
            <select class="form-control"  name="status" formControlName="status" [(ngModel)]="model.status">
                <option *ngFor="let item of statusListEnum" [ngValue]="item.value">
                    {{ documentProcessToStatusTranslate.get(item.value) | translate }}
                </option>
            </select>
            </div>
            </div>
            <div>
            <button type="submit" class="btn btn-primary btn-sm mr-2" style="margin-top: 30px; margin-bottom: 20px; padding: 10px;" (click)="onSubmit()">
                {{ "form.clearFilters" | translate }}
            </button>
        </div>
          
          </form>
        <div class="table-body">
            <table class="table table-striped table-bordered">
                <thead>
                    <tr class="table-names">
                        <th>{{ "documentsGrid.typeOfConstancy" | translate }}</th>
                        <th>{{ "documentsGrid.numberOfConstancy" | translate }}</th>
                        <th>{{ "documentsGrid.numberOfInscription" | translate }}</th>
                        <th>{{ "documentsGrid.documentProcessUpdateDate" | translate }}</th>
                        <th>{{ "documentsGrid.documentProcessStatus" | translate }}</th>
                        <th>{{ "actions" | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let apiDocument of apiDocuments.items| documentFilter:model.startDate: model.endDate: model.organization: model.sintraId: model.constancyType: model.status: model; let i = index">
                        <th class="text-center">{{ constancyType[apiDocument.constancyType] }}</th>
                        <th class="text-center">{{ apiDocument.constancyNumber }}</th>
                        <th class="text-center">{{ apiDocument.registrationNumber }}</th>
                        <th class="text-center">{{ apiDocument.documentProcessUpdateDate }}</th>
                        <th class="text-center">
                            {{ documentProcessToStatusTranslate.get(apiDocument.documentProcessStatus) | translate }}{{flagPending(apiDocument)}}
                        </th>
                        <th class="text-center">
                            <div class="custom-control custom-switch"  style="padding-left: 0">
                                <app-button icon="fa-check-circle" (buttonClick)="downloadQR(apiDocument)"
                                    [info]="translate.instant('documentsGrid.downloadQRFile')"
                                    *ngIf="apiDocument.isAbleToDownloadFile"
                                    style="display: none;margin-right: 5%;">
                                </app-button>
                                <app-button icon="fa-chevron-right" (buttonClick)="seeDetailsClick(apiDocument)"
                                    [info]="translate.instant('seeDetails')" [disable]="false"
                                    style="display: inline-block;">
                                </app-button>
                            </div>
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
        <app-pagination 
        [options]="options" 
        [pagedList]="apiDocuments"
        [callback]="loadData"
        ></app-pagination>
        <div class="table-bottom">

        </div>
    </div>
</div> 